import { render } from "./CarouselClientes.vue?vue&type=template&id=f226774c"
import script from "./CarouselClientes.vue?vue&type=script&lang=js"
export * from "./CarouselClientes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__